import React, { ReactNode, useContext, useState } from "react";
import { AccountBean } from "src/api/api";
type RoleEnum = AccountBean.RoleEnum;

export interface User {
  id: number;
  username: string;
  role: RoleEnum | undefined;
  publisherId?: number;
  dspId?: number;
}

const Context = React.createContext<
  | {
      user: User | undefined;
      setUser: (user: User) => void;
    }
  | undefined
>(undefined);

export const useUser = () => {
  const context: any = useContext(Context);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};

interface UserProviderProps {
  children: ReactNode;
}

const UserProvider: React.FC<UserProviderProps> = ({ children }) => {
  const [user, setUser] = useState<User>();

  return (
    <Context.Provider value={{ user, setUser }}>{children}</Context.Provider>
  );
};

export default UserProvider;
